// Greek laurel wreath — two mirrored branches surrounding a hollow center.
// Pure SVG, scales to whatever size you place it at.
export default function LaurelWreath({ className = "", color = "#FFB72E", strokeColor = "#A02157" }) {
  // One half-branch path (will be mirrored for the right side)
  const leafPath = (
    <g fill={color} stroke={strokeColor} strokeWidth="1.2" strokeLinejoin="round">
      {/* Stem */}
      <path
        d="M50 96 C 38 80, 30 64, 28 46 C 27 32, 30 18, 36 8"
        fill="none"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Leaves on outer side */}
      <ellipse cx="32" cy="78" rx="7" ry="3.2" transform="rotate(-40 32 78)" />
      <ellipse cx="27" cy="66" rx="8" ry="3.4" transform="rotate(-30 27 66)" />
      <ellipse cx="24" cy="54" rx="9" ry="3.6" transform="rotate(-20 24 54)" />
      <ellipse cx="23" cy="42" rx="9" ry="3.6" transform="rotate(-10 23 42)" />
      <ellipse cx="25" cy="30" rx="8.5" ry="3.4" transform="rotate(5 25 30)" />
      <ellipse cx="29" cy="19" rx="7.5" ry="3.2" transform="rotate(18 29 19)" />
      <ellipse cx="34" cy="10" rx="6.5" ry="3" transform="rotate(32 34 10)" />
      {/* Leaves on inner side */}
      <ellipse cx="40" cy="84" rx="6" ry="2.6" transform="rotate(-60 40 84)" />
      <ellipse cx="35" cy="72" rx="7" ry="2.8" transform="rotate(-55 35 72)" />
      <ellipse cx="33" cy="60" rx="7.5" ry="3" transform="rotate(-48 33 60)" />
      <ellipse cx="33" cy="48" rx="7.5" ry="3" transform="rotate(-40 33 48)" />
      <ellipse cx="35" cy="36" rx="7" ry="2.8" transform="rotate(-25 35 36)" />
      <ellipse cx="39" cy="24" rx="6.5" ry="2.6" transform="rotate(-10 39 24)" />
    </g>
  );

  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Left branch */}
      {leafPath}
      {/* Right branch — mirrored */}
      <g transform="translate(100,0) scale(-1,1)">{leafPath}</g>
      {/* Ribbon knot at the bottom */}
      <circle cx="50" cy="97" r="2.6" fill={strokeColor} />
    </svg>
  );
}
